let colors = {
  INTERFACE_COLORS_BASALT: "rgb(25, 20, 20)",
  INTERFACE_COLORS_LAVABEE_YELLOW: "rgb(255, 213, 80)",
  INTERFACE_COLORS_STONE: "rgb(162, 155, 139)",
  INTERFACE_COLORS_LIGHT_STONE: "rgb(204, 196, 179)",
  INTERFACE_COLORS_DARK_STONE: "rgb(117, 114, 114)",
  INTERFACE_COLORS_LIGHT_GRAY: "rgb(240, 240, 240)",
  SYSTEM_ERROR: "rgb(245, 86, 86)",
  SYSTEM_WARNING: "rgb(255, 155, 38)",
  SYSTEM_INFO: "rgb(94, 96, 233)",
  SYSTEM_SUCESS: "rgb(66, 186, 114)",
  TEXT_DARK_GRAY: "rgb(27, 31, 36)",
  TEXT_GRAY_4B: "rgb(75, 75, 75)",
  TEXT_GRAY_72: "rgb(114, 114, 114)",
  TEXT_WHITE: "rgb(255, 255, 255)",
};

export default colors;
